import { GET_BPT_PREFERENCE_ANALYSIS_CONSIDERATION_ASYNC } from './actions';

export const considerationTabReducer = (state = null, action) => {
    switch (action.type) {
        case GET_BPT_PREFERENCE_ANALYSIS_CONSIDERATION_ASYNC.actions.SUCCEEDED:
            return action.payload;
        case GET_BPT_PREFERENCE_ANALYSIS_CONSIDERATION_ASYNC.actions.FAILED:
            return null;
        default:
            return state;
    }
};
